import PrepaidAccountBalance from '@/components/PrepaidAccountBalance';
import WarningActionBox from '@/components/Common/WarningActionBox';
import ConfigurationModal from '@/components/Common/ConfigurationModal';

// @vue/component
export default {
  name: 'ShPageHeader',

  components: {
    PrepaidAccountBalance,
    WarningActionBox,
    ConfigurationModal,
  },

  props: {
    title: {
      type: String,
      default: 'Page header title',
    },
    description: {
      type: String,
      default: null,
    },
    descriptionInModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isConfigurationModalVisible: false,
      isWarningWindowVisible: false,
      widgetIdForRequiredNumberVerification: 0,
    };
  },
  computed: {
    user() {
      return this.$store.getters['authorization/user'];
    },
    isPrepaid() {
      // eslint-disable-next-line camelcase
      return this.user?.access?.account_type === 'prepaid';
    },
    domainsList() {
      return this.$store.getters['domains/list'];
    },
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'domains/getList',
        'widgets/getList',
      ]);
    },
    isWarningActionBoxVisible() {
      return !this.isLoading
        && this.user.users_permissions_profiles_id_fk === 3
        && this.domainsList.length <= 0
        && !this.isConfigurationModalVisible;
    },
  },
  mounted() {
    this.$EventBus.$on('widget/TOGGLE_CONFIG_MODAL', (params) => {
      this.isConfigurationModalVisible = params.toggleNumberRequired;
      this.widgetIdForRequiredNumberVerification = params.widgetId;
    });
  },

  beforeDestroy() {
    this.$EventBus.$off('widget/TOGGLE_CONFIG_MODAL');
  },
  async beforeCreate() {
    await this.$store.dispatch('widgets/getList');
    await this.$store.dispatch('domains/getList');
    this.isConfigurationModalVisible = (
      !this.isLoading
      && this.user.users_permissions_profiles_id_fk === 3
      && !document.cookie.includes('was_configuration_modal_shown')
      && this.domainsList.length <= 0
    );
  },
  methods: {
    closeConfigModal() {
      this.isConfigurationModalVisible = false;
      this.widgetIdForRequiredNumberVerification = 0;
    },
  },
};
